import { PrivacySettings } from 'client/modules/privacy/types';

type PrivacySettingKey = keyof PrivacySettings;
type PrivacySettingSetter = (value: boolean) => void;

/**
 * Stack'd Perps stub: privacy is always off — values are always visible.
 * Returns [false, noop] for any privacy key.
 */
export function usePrivacySetting(
  _key: PrivacySettingKey,
): [boolean, PrivacySettingSetter] {
  return [false, () => {}];
}
